import role from '@/auth/role'

export default [
  {
    path: '/user/profile',
    name: 'user-profile-edit',
    component: () => import('@/views/user/ProfileEdit.vue'),
    meta: {
      title: 'user.profile.title',
      access: [role.educator, role.student, role.guardian],
      breadcrumb: [
        { text: 'user.profile.title', active: true },
      ],
    },
  },
]
